import React from 'react';
import {Modal, Tab, Icon, Message} from 'semantic-ui-react';
import WtsRevisionMatricula from './modalRevisarMatriculados/WtsRevisionMatricula';
import WtsRevisionMatriculaHistorico from './modalRevisarMatriculados/WtsRevisionMatriculaHistorico';
import WtsCalificacionMatriculados from './modalRevisarMatriculados/WtsCalificacionMatriculados';
import WtsDocumentacionFinal from './modalRevisarMatriculados/WtsDocumentacionFinal';

const WtsMatriculaIndex = ({open, onClose, courseToEdit, reduxData}) => {
  if (!open || !courseToEdit) {
    return null;
  }

  const status = courseToEdit?.status || courseToEdit?.estado;
  let content;

  if (status === 'I') {
    content = (
      <Message
        info
        icon="info circle"
        header="Curso Ingresado"
        content="El curso está en estado INGRESADO, sin opciones disponibles."
      />
    );
  } else {
    const panes = [];

    if (['A', 'E', 'C', 'X'].includes(status)) {
      panes.push({
        'menuItem': {
          'key': 'active',
          'icon': 'user',
          'content': 'Inscripciones Activas',
        },
        'render': () => (
          <Tab.Pane style={{'border': 'none', 'padding': '10px 0 0 0', 'boxShadow': 'none'}}>
            <WtsRevisionMatricula
              courseToEdit={courseToEdit}
              reduxData={reduxData}
              onClose={onClose}
            />
          </Tab.Pane>
        ),
      });

      panes.push({
        'menuItem': {
          'key': 'history',
          'icon': 'history',
          'content': 'Historial de Inscripciones',
        },
        'render': () => (
          <Tab.Pane style={{'border': 'none', 'padding': '10px 0 0 0', 'boxShadow': 'none'}}>
            <WtsRevisionMatriculaHistorico
              courseToEdit={courseToEdit}
              reduxData={reduxData}
              onClose={onClose}
            />
          </Tab.Pane>
        ),
      });
    }

    if (['E', 'C', 'X'].includes(status)) {
      panes.push({
        'menuItem': {
          'key': 'grades',
          'icon': 'star',
          'content': 'Calificaciones',
        },
        'render': () => (
          <Tab.Pane style={{'border': 'none', 'padding': '10px 0 0 0', 'boxShadow': 'none'}}>
            <WtsCalificacionMatriculados
              courseToEdit={courseToEdit}
              reduxData={reduxData}
              onClose={onClose}
            />
          </Tab.Pane>
        ),
      });
    }

    if (['C', 'X'].includes(status)) {
      panes.push({
        'menuItem': {
          'key': 'final-docs',
          'icon': 'file pdf outline',
          'content': 'Documentación Final',
        },
        'render': () => (
          <Tab.Pane style={{'border': 'none', 'padding': '10px 0 0 0', 'boxShadow': 'none'}}>
            <WtsDocumentacionFinal
              courseToEdit={courseToEdit}
              reduxData={reduxData}
              onClose={onClose}
            />
          </Tab.Pane>
        ),
      });
    }

    content = (
      <Tab
        menu={{'secondary': true, 'pointing': true}}
        panes={panes}
      />
    );
  }

  return (
    <Modal open={open} onClose={onClose} size="fullscreen" closeIcon>
      <Modal.Header>
        <Icon name="user" /> Gestión de Estudiantes
      </Modal.Header>
      <Modal.Content scrolling style={{'backgroundColor': '#f9fafb', 'minHeight': '500px'}}>
        {content}
      </Modal.Content>
    </Modal>
  );
};

export default WtsMatriculaIndex;
